import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import '../../assets/css/Profile.css';
import CustomButton from "../../components/CustomButton";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import MultiRangeSlider from "multi-range-slider-react";

const YourSports = ({ yourSportsData, onPlayerList, onSelectedMenu }) => {
    const [skillLevel, setSkillLevel] = useState("Beginner");
    const [gender, setGender] = useState('');
    const [preference, setPreference] = useState();
    const [minValue, setMinValue] = useState(25);
    const [maxValue, setMaxValue] = useState(75);
    const [minValue2, setMinValue2] = useState(0);
    const [maxValue2, setMaxValue2] = useState(0);
    const [gameId, setGameId] = useState();
    const [skillLevelNum, setSkillLevelNum] = useState(0);
    const [reliabilityPercentage, setReliabilityPercentage] = useState(0);

    const { accessToken } = useSelector((state) => state.loginInfo);
    const navigate = useNavigate();

    const genderOptions = ["Male", "Female", "All"];

    const tennisLevels = [
        "Practice",
        "Beginner",
        "Intermediate",
        "Upper-Intermediate",
        "Proficient",
        "League Player",
        "Young Pro Player",
        "College Player",
    ];

    const { gameProfileId } = yourSportsData || {};
    const { userProfileResponse } = yourSportsData || {};
    const { sportName } = yourSportsData || {};

    const handleGenderChange = (value) => {
        setGender(value);
    };

    const handlePreferenceChange = (level) => {
        setPreference(level);
    };

    const formatSkillLevel = (level) => {
        if (!level) return undefined;
        return level.trim().replace(/[-\s]/g, '_').toUpperCase();
    };

    const toTitleCase = (input) => {
        return input?.toLowerCase().split('_').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
    };

    const handleYourSport = async () => {
        try {
            const data = [
                {
                    sportId: 1,
                    gender: gender?.toUpperCase(),
                    preferMinAge: minValue2,
                    preferMaxAge: maxValue2,
                    skillLevel: formatSkillLevel(skillLevel),
                    preferredSkillLevel: formatSkillLevel(preference),
                },
            ];

            const result = await apiHandler({
                url: endpoint?.CREATE_TENNIS_PROFILE,
                method: 'POST',
                data: data,
                authToken: accessToken?.accessToken,
            });

            if (result?.data?.length >= 1) {
                toast.success("Profile created successfully!");
                navigate('/profile');
                onSelectedMenu("player-profile");
            } else {
                toast.error("Failed to create profile. Please try again.");
            }
        } catch (error) {
            toast.error("An error occurred while creating the profile. Please try again.");
        }
    };

    useEffect(() => {
        if (!userProfileResponse || !sportName) return;

        const result = userProfileResponse.find(
            (profile) => profile?.gameName?.toLowerCase() === sportName?.toLowerCase()
        );

        if (result) {
            setGender(toTitleCase(result.gender));
            setSkillLevel(toTitleCase(result.skillLevel) || 'Beginner');
            setMinValue(result.preferMinAge);
            setMaxValue(result.preferMaxAge);
            setMinValue2(result.preferMinAge);
            setMaxValue2(result.preferMaxAge);
            setPreference(toTitleCase(result.preferredSkillLevel));
            setSkillLevelNum(result.skillLevelNum);
            setReliabilityPercentage(result.reliabilityPercentage || 0);
        }
    }, [userProfileResponse, sportName]);

    useEffect(() => {
        setGameId(gameProfileId);
    }, [gameProfileId]);

    return (
        <div className="your-sports-wrapper p-sm-3 p-sm-0 bg-white m-3 m-sm-0">
            <div className="profile-content-wrapper p-3">
                <div className="text-primary text-end player-list-text mb-2 mb-sm-0" onClick={() => onPlayerList(gameId)}>
                    <span style={{ cursor: 'pointer' }}>Players list </span>
                </div>
                <div className="d-flex justify-content-between">
                    <span className="form-label">Your {sportName} & Reliability Level</span>
                </div>

                <div className="container mt-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="form-label">Skill level</span>
                        <div className="progress" style={{ width: "70%" }}>
                            <div
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                    width: `${skillLevelNum}%`,
                                    backgroundColor: "#e91e63",
                                }}
                            ></div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <span className="form-label">Reliability</span>
                        <div className="progress" style={{ width: "70%" }}>
                            <div
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                    width: `${reliabilityPercentage}%`,
                                    backgroundColor: "#4caf50",
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row profile-content-wrapper my-3 mx-0 p-3">
                <div className="col-lg-6 ">
                    <div className="mt-sm-3 pt-sm-4 col-lg-12">
                        <label htmlFor="skillLevel" className="form-label">Choose Your Skill Level</label>
                        <select
                            id="skillLevel"
                            className="form-select your-sport-label dropdown-style"
                            value={skillLevel}
                            onChange={(e) => setSkillLevel(e.target.value)}
                        >
                            {tennisLevels.map((level) => (
                                <option key={level} value={level}>
                                    {level}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="my-4 col-lg-12">
                        <div className="mb-4 border p-4 ps-5">
                            <p className="form-label" style={{ marginLeft: '-11px' }}>Gender</p>
                            {genderOptions.map((option) => (
                                <div className="form-check pb-2 d-flex align-items-end" key={option}>
                                    <input
                                        type="radio"
                                        className="form-check-input fs-4 me-2"
                                        id={option.toLowerCase()}
                                        name="gender"
                                        value={option}
                                        onChange={() => handleGenderChange(option)}
                                        checked={gender?.toLowerCase() === option.toLowerCase()}
                                    />
                                    <label className="form-check-label your-sport-label" htmlFor={option.toLowerCase()}>
                                        {option}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <p className="preferable-age form-label">Preferable Age</p>
                        <MultiRangeSlider
                            baseClassName="multi-range-slider-black"
                            minValue={minValue}
                            maxValue={maxValue}
                            onInput={(e) => {
                                setMinValue(e.minValue);
                                setMaxValue(e.maxValue);
                            }}
                            onChange={(e) => {
                                setMinValue2(e.minValue);
                                setMaxValue2(e.maxValue);
                            }}
                        />
                        <div className="d-flex justify-content-center mt-3">
                            <input
                                type="number"
                                className="form-control me-2 range-input-box"
                                name="min"
                                value={minValue}
                                disabled
                            />
                            <input
                                type="number"
                                className="form-control ms-2 range-input-box"
                                name="max"
                                value={maxValue}
                                disabled
                            />
                        </div>
                    </div>
                </div>

                <div className="mt-4 col-lg-6">
                    <h5 className="mt-3 mb-3 your-preference-txt form-label">Your Preferences</h5>
                    <div className="border p-3">
                        <p className="mt-4 mb-4 ms-2 me-4">Skill Level</p>
                        {tennisLevels.map((level) => (
                            <div className="form-check m-3" key={level}>
                                <input
                                    type="checkbox"
                                    id={level}
                                    className="form-check-input fs-4"
                                    checked={formatSkillLevel(preference) === formatSkillLevel(level)}
                                    onChange={() => handlePreferenceChange(level)}
                                />
                                <label htmlFor={level} className="form-check-label your-sport-label">
                                    {level}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-4 mb-sm-4 your-sport-button">
                    <CustomButton
                        buttonText={"Save"}
                        className="border"
                        style={{
                            width: "90%",
                            height: "48px",
                            borderRadius: "12px",
                            background: "#006FFD",
                            color: "#FFFFFF",
                        }}
                        onClick={handleYourSport}
                    />
                </div>
            </div>
        </div>
    );
};

export default YourSports;
